import { Component } from '@angular/core';
import { RidButton } from '../../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-odd-one-out-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './odd-one-out-page.html',
})
export class OddOneOutPage {}
